<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="discountsField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeDiscountsField] ? 'Exclude' : 'Include')} Discounts`"
      :options="discounts.data"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      bottom-slots
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one discount'
      ]"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeDiscountsField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'

export default {
  name: 'DiscountsConditionForm',
  configuration: ['discounts'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    discountsField: {
      type: String,
      default: CONDITION_REQUIREMENTS.DISCOUNTS
    },
    excludeDiscountsField: {
      type: String,
      default: CONDITION_REQUIREMENTS.EXCLUDE_DISCOUNTS
    }
  }
}

</script>
